export const SET_THEME = 'SETTHEME';
export const SET_DARK = 'SETDARK';
export const SET_LANG = 'SETLANG';

export const setTheme = (payload) => ({ type: SET_THEME, payload });
export const setDark = (payload) => ({ type: SET_DARK, payload });
export const setLang = (payload) => ({ type: SET_LANG, payload });
